import { z } from 'zod';

/** The note is shown to the shopper on the invoice (1000 chars); staff notes never leave the admin (5000). */
export const notesSchema = z.object({
  note: z.string().trim().max(1000, { error: 'draftOrders:notes.validation.length' }),
  staffNotes: z.string().trim().max(5000, { error: 'draftOrders:notes.validation.staffLength' }),
  tags: z.array(z.string()).max(50, { error: 'draftOrders:notes.validation.tags' }),
});

export type NotesFormInput = z.input<typeof notesSchema>;
export type NotesFormOutput = z.output<typeof notesSchema>;
